import { render, staticRenderFns } from "./dictionary-form.vue?vue&type=template&id=024f8818&scoped=true&"
import script from "./dictionary-form.vue?vue&type=script&lang=js&"
export * from "./dictionary-form.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-form.vue?vue&type=style&index=0&id=024f8818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f8818",
  null
  
)

export default component.exports